import axios from 'axios'

import { buildAuthApi } from '@/services/api/auth'
import { buildCaseWorkersApi } from '@/services/api/case-workers'
import { buildDashboardTasksApi } from '@/services/api/dashboard-tasks'
import { buildFeatureFlagsApi } from '@/services/api/feature-flags'
import { buildFeedbacksApi } from '@/services/api/feedbacks'
import { buildFilterTemplatesApi } from '@/services/api/filter-templates'
import { buildReportTemplatesApi } from '@/services/api/report-templates'
import { buildResourcesApi } from '@/services/api/resources'
import { buildTasksApi } from '@/services/api/tasks'
import { IApi } from '@/spi/api'

import { buildBeneficiariesApi } from './beneficiaries'
import { buildBeneficiariesInsightsApi } from './beneficiaries-insights'
import { buildCaseWorkerPreferencesApi } from './case-worker-preferences'

export const buildApi = ({ baseURL }: { baseURL: string }): IApi => {
  const axiosInstance = axios.create({ baseURL: baseURL + '/' })
  return {
    setAccessToken: (accessToken: string) => {
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    },
    auth: buildAuthApi(axiosInstance),
    beneficiaries: buildBeneficiariesApi(axiosInstance),
    caseWorkerPreferences: buildCaseWorkerPreferencesApi(),
    beneficiariesInsights: buildBeneficiariesInsightsApi(axiosInstance),
    caseWorkers: buildCaseWorkersApi(axiosInstance),
    dashboardTasks: buildDashboardTasksApi(axiosInstance),
    featureFlags: buildFeatureFlagsApi(axiosInstance),
    feedbacks: buildFeedbacksApi(axiosInstance),
    filterTemplates: buildFilterTemplatesApi(axiosInstance),
    reportTemplates: buildReportTemplatesApi(axiosInstance),
    resources: buildResourcesApi(axiosInstance),
    tasks: buildTasksApi(axiosInstance),
  }
}
